import * as React from 'react';
import { storiesOf } from '@storybook/react';
import { VisualTestContainer } from '../../test/visual/VisualTestContainer';
import { TextButtonPriority, TextButton, HoverStyles } from '..';
import { TPAComponentsProvider } from '../TPAComponentsConfig';
import { Text } from '../Text';
import { LikeHeart } from '@wix/wix-ui-icons-common/on-stage';

class TextButtonVisual extends React.Component<any> {
  static defaultProps = {
    mobile: false,
  };

  render() {
    const { mobile } = this.props;

    return (
      <TPAComponentsProvider value={{ mobile }}>
        <VisualTestContainer>
          <TextButton {...this.props}>Text Button</TextButton>
        </VisualTestContainer>
      </TPAComponentsProvider>
    );
  }
}

const tests = [
  {
    describe: 'basic',
    its: [
      {
        it: 'default',
        props: {},
      },
      {
        it: 'mobile',
        props: {
          mobile: true,
        },
      },
      {
        it: 'primary',
        props: {
          priority: TextButtonPriority.primary,
        },
      },
      {
        it: 'secondary',
        props: {
          priority: TextButtonPriority.secondary,
        },
      },
      {
        it: 'primaryLink',
        props: {
          priority: TextButtonPriority.primaryLink,
        },
      },
    ],
  },
  {
    describe: 'With icons',
    its: [
      {
        it: 'with suffixIcon',
        props: {
          suffixIcon: <LikeHeart />,
        },
      },
      {
        it: 'with prefixIcon',
        props: {
          prefixIcon: <LikeHeart />,
        },
      },
      {
        it: 'with suffixIcon as Text',
        props: {
          suffixIcon: <Text>suffix as Text</Text>,
        },
      },
      {
        it: 'with prefixIcon as Text',
        props: {
          prefixIcon: <Text>prefix as Text</Text>,
        },
      },
    ],
  },
  {
    describe: 'Underline hover',
    its: [
      {
        it: 'default',
        props: { hoverStyle: HoverStyles.underline, autoFocus: true },
      },
      {
        it: 'mobile',
        props: {
          hoverStyle: HoverStyles.underline,
          mobile: true,
          autoFocus: true,
        },
      },
      {
        it: 'primary',
        props: {
          hoverStyle: HoverStyles.underline,
          priority: TextButtonPriority.primary,
          autoFocus: true,
        },
      },
      {
        it: 'secondary',
        props: {
          hoverStyle: HoverStyles.underline,
          autoFocus: true,
          priority: TextButtonPriority.secondary,
        },
      },
      {
        it: 'with main font overrides',
        props: {
          hoverStyle: HoverStyles.underline,
          style: { '--wix-ui-tpa-text-button-main-text-font-size': '22px' },
          autoFocus: true,
        },
      },
      {
        it: 'with hover font overrides',
        props: {
          hoverStyle: HoverStyles.underline,
          style: { '--wix-ui-tpa-button-hover-text-font-size': '22px' },
          autoFocus: true,
        },
      },
    ],
  },
  {
    describe: 'with wst variables',
    its: [
      {
        it: 'primary',
        props: {
          priority: TextButtonPriority.primary,
          suffixIcon: <LikeHeart />,
        },
        style: {
          '--wst-links-and-actions-color-rgb': '250,150,0',
        },
      },
      {
        it: 'secondary',
        props: {
          priority: TextButtonPriority.secondary,
          prefixIcon: <LikeHeart />,
        },
        style: {
          '--wst-paragraph-2-color-rgb': '0,100,180',
        },
      },
      {
        it: 'link',
        props: {
          priority: TextButtonPriority.link,
        },
        style: {
          '--wst-paragraph-2-color-rgb': '0,100,180',
        },
      },
      {
        it: 'primaryLink',
        props: {
          priority: TextButtonPriority.primaryLink,
        },
        style: {
          '--wst-links-and-actions-color-rgb': '250,150,0',
        },
      },
      {
        it: 'disabled state',
        props: {
          disabled: true,
        },
        style: {
          '--wst-system-disabled-color-rgb': '100,0,100',
        },
      },
      {
        it: 'primary with font',
        props: {
          priority: TextButtonPriority.primary,
          suffixIcon: <LikeHeart />,
        },
        style: {
          '--wst-links-and-actions-color-rgb': '250,150,0',
          '--wst-paragraph-2-font-family': 'Libre Baskerville',
          '--wst-paragraph-2-font-weight': 'bold',
          '--wst-paragraph-2-font-size': '22px',
          '--wst-paragraph-2-font-style': 'italic',
          '--wst-paragraph-2-font-variant': 'small-caps',
        },
      },
      {
        it: 'secondary with font',
        props: {
          priority: TextButtonPriority.secondary,
          prefixIcon: <LikeHeart />,
        },
        style: {
          '--wst-paragraph-2-color-rgb': '250,150,0',
          '--wst-paragraph-2-font-family': 'Libre Baskerville',
          '--wst-paragraph-2-font-weight': 'bold',
          '--wst-paragraph-2-font-size': '22px',
          '--wst-paragraph-2-font-style': 'italic',
          '--wst-paragraph-2-font-variant': 'small-caps',
        },
      },
      {
        it: 'link with font',
        props: {
          priority: TextButtonPriority.link,
        },
        style: {
          '--wst-paragraph-2-color-rgb': '250,150,0',
          '--wst-paragraph-2-font-family': 'Libre Baskerville',
          '--wst-paragraph-2-font-weight': 'bold',
          '--wst-paragraph-2-font-size': '22px',
          '--wst-paragraph-2-font-style': 'italic',
          '--wst-paragraph-2-font-variant': 'small-caps',
        },
      },
      {
        it: 'primaryLink with font',
        props: {
          priority: TextButtonPriority.primaryLink,
        },
        style: {
          '--wst-links-and-actions-color-rgb': '250,150,0',
          '--wst-paragraph-2-font-family': 'Libre Baskerville',
          '--wst-paragraph-2-font-weight': 'bold',
          '--wst-paragraph-2-font-size': '22px',
          '--wst-paragraph-2-font-style': 'italic',
          '--wst-paragraph-2-font-variant': 'small-caps',
        },
      },
    ],
  },
];

tests.forEach(({ describe, its }) => {
  its.forEach(({ it, props, style }) => {
    storiesOf(`TextButton/${describe}`, module).add(it, () => (
      <div style={style}>
        <TextButtonVisual {...props} />
      </div>
    ));
  });
});
